module.exports = __webpack_public_path__ + "7ac1390902567cf1757699d797bd0d78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000FXV.png
// module id = 1584
// module chunks = 0